// removed by extract-text-webpack-plugin
module.exports = {"container":"_-4EDL8PkaA4cv3RBbwdjw"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OutfeatPreview/OutfeatPreview.scss
 ** module id = 739
 ** module chunks = 0
 **/